// Bootstrap JS handles carousel via data-bs-ride="carousel"
// No custom JS needed if Bootstrap JS is loaded in the theme
